import { IMainPageAction } from '../../../types/mainpage';
import { INewbuildingRecommendations } from '../../../types/newbuilding_recommendations';

export const GET_NEWBUILDING_RECOMMENDATIONS = 'mainpage/GET_NEWBUILDING_RECOMMENDATIONS';

export const EXPERIMENTS_GET_SUCCESS = 'mainpage/EXPERIMENTS_GET_SUCCESS';

/* istanbul ignore next */
export const experimentsSuccess = (data: { experiments: {} }): IMainPageAction => {
  return {
    experiments: data.experiments,
    type: EXPERIMENTS_GET_SUCCESS,
  };
};

/* istanbul ignore next */
export const getNewbuildingRecommendations = (recommendations: INewbuildingRecommendations[]): IMainPageAction => {
  return {
    type: GET_NEWBUILDING_RECOMMENDATIONS,
    newbuilding_recommendations: recommendations,
  };
};
